import AsideLayout from '../baseLayouts/AsideLayout';

export const withAdminLayout = (Component: React.ComponentType) => {
  const WrappedComponent = (props: any) => (
    <AsideLayout>
      <Component {...props} />
    </AsideLayout>
  );
  return WrappedComponent;
};
